<article class="comment-card-container">
  <img [src]="url" alt="user picture" class="user-picture" width="71px" />
  <h5 [title]="displayName || ''" class="title">{{ name || "Usuario..." }}</h5>
  <small [title]="data.created" class="date"><i class="bi bi-clock"></i> {{data.created | date : "dd/MM/yyyy" | relativeDateFormat}}</small>
  <div class="body" [innerHTML]="data.comment_body_value || ''"></div>
  <div
  title="{{ 'Responder a ' + name +' (' || ''+') ' }}"
  *ngIf="
    !toComment && !(data.thread_array.length >= this.maxCommentResponsesDeep)
  "
  (click)="onComment()"
  class="card-reply"
  >
  Responder
  </div>
  <app-input-comment-tribe
    [buttonText]="'Responder'"
    *ngIf="toComment"
    (onPublishComment)="onReponseComment($event)"
    [urlImageProfileLogued]="urlImageProfileLogued"
  />

  <div class="comment-card-response-container">
    <ul>
      <li *ngFor="let item of data.children" class="comment-card-response-item">
        <app-card-comment-tribe
          [fatherThread]="item.thread"
          [data]="item"
        />
      </li>
    </ul>
  </div>
</article>








